import { gql } from "@apollo/client";

import { SEARCH_SUGGESTIONS_FRAGMENT } from "constants/suggestions";

export const SEARCH_POLICIES_TEMPLATES = gql`
  query SearchPoliciesTemplates($input: SearchInput!) {
    searchPolicyTemplates(input: $input) {
      pageInfo {
        endCursor
        hasNextPage
      }
      edges {
        cursor
        node {
          name
          id
          type
          body
          description
          labels
        }
      }
    }
  }
`;

export const SEARCH_POLICIES_TEMPLATES_SUGGESTIONS = gql`
  query SearchPoliciesTemplatesSuggestions($input: SearchSuggestionsInput!) {
    searchPolicyTemplatesSuggestions(input: $input) {
      ...SearchSuggestionsFragment
    }
  }
  ${SEARCH_SUGGESTIONS_FRAGMENT}
`;
